import React, { useMemo } from 'react'
import { RI_CLIC_ITI, TAG_MULTIPATH_CTA } from '../analytics/analytics.tagids.constants'
import { CLICKED_BUTTON } from '../analytics/analytics.constants'
import { PUB_TAG } from '../analytics/PublisherTags.tags'
import { withOnlyPE } from '../Device'
import RectangleActionButton, { COLOR_BLUE, SIZE_MEDIUM } from '../genericComponents/buttons/RectangleActionButton'
import TagActionButton from '../genericComponents/TagActionButton'
import { getGpsLink } from './gps.utils'
import ItineraryButtonContainer from './ItineraryButtonContainer'
import mappyOutline from './mappy_outline.svg'
import { useDeepLinking } from '../../utils/useDeepLinking'

const GPSButton = ({ elementRef, gpsInfo, className }) => {
  const gpsLink = useMemo(() => getGpsLink(gpsInfo), [gpsInfo])
  const openDeepLink = useDeepLinking(gpsLink)

  if (!gpsLink) return <></>

  return (
    <ItineraryButtonContainer className={className}>
      <TagActionButton type={RI_CLIC_ITI} key={gpsInfo} isSpan>
        <RectangleActionButton
          color={COLOR_BLUE}
          elementRef={elementRef}
          onClick={() => openDeepLink()}
          deferClick
          tagData={{
            tagInfo: { provider: gpsInfo.provider, tag: PUB_TAG.PUB_MULTIPATH_GPS },
            type: TAG_MULTIPATH_CTA,
            shouldTagImpression: true,
          }}
          label={gpsInfo.label}
          iconUrl={mappyOutline}
          ssrWhite
          dataset={{ [CLICKED_BUTTON]: gpsInfo.label }}
          size={SIZE_MEDIUM}
        />
      </TagActionButton>
    </ItineraryButtonContainer>
  )
}

export default withOnlyPE(GPSButton)
